export default __webpack_public_path__ + "static/media/widowmaker-oneshot.8e11352d.mp3";